import { render } from "./FishTabs.vue?vue&type=template&id=72b430c2&scoped=true"
import script from "./FishTabs.vue?vue&type=script&lang=js"
export * from "./FishTabs.vue?vue&type=script&lang=js"

import "./FishTabs.vue?vue&type=style&index=0&id=72b430c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72b430c2"]])

export default __exports__